
/** @format */
import React, { useEffect, useRef } from 'react';
import NeshanMap from 'components/NeshanMap';
import { Grid } from '@mui/material';
import { useStyles } from './style';
import { InputV2, AutocompleteV, InfoBox, ProvinceCityListComponent } from 'components';
import { useFormContext } from 'react-hook-form';
import _ from 'lodash';
import Services from './services/ContactUsServices';
import useCustomHook from './hooks';

const ContactUs = ({
  city,
  setCity,
  setCityId,
  province,
  setProvince,
  setProvinceId,
  setLatitude,
  latitude,
  businessInfo
}) => {
  // --STATES--//
  const {
    states,
    setStates,
    searchResult,
    setSearchResult,
    cities,
    setCities,
    selectedLocation,
    setSelectedLocation,
    locationSearchText,
    setLocationSearchText,
    loadingStates,
    setLoadingStates,
    loadingCities,
    setloadingCities,
    nationalCode,
    setNationalCode
  } = useCustomHook();

  // --HOOKS--//
  const methods = useFormContext();

  const classes = useStyles();

  const marker = useRef();
  const map = useRef();

  useEffect(() => {
    setNationalCode(businessInfo?.nationalCode)

  }, [businessInfo]);

  useEffect(() => {
    if (!locationSearchText.length) {
      setSelectedLocation(false);
    }
    if (locationSearchText && !selectedLocation) {
      delayedSearch(locationSearchText, onSearch);
    }
  }, [locationSearchText]);
  const onSearch = async () => {
    let obj = {
      term: locationSearchText,
      lat: latitude.lat,
      lng: latitude.lng,
    };

    try {
      let res = await Services.neshanSearch(obj);
      setSearchResult(
        res.data.items.map((item) => {
          return {
            label: item.title + ' ' + item.region,
            name: item.title,
            value: item.location.x + item.location.y,
            id: item.location.x + item.location.y,
            latitude: item.location,
          };
        }),
      );
    } catch (e) { }
  };

  useEffect(() => {
    if (latitude.lat && latitude.lng) {
      if (marker.current) marker.current.setLatLng(latitude).update();

      if (map.current) map.current.panTo(latitude);
    }
  }, [latitude.lat, latitude.lng]);

  const delayedSearch = useRef(_.debounce((v, f) => f(v), 800)).current;
  return (
    <Grid container direction="row">
      <InfoBox
        type="disable"
        content="در این بخش اطلاعات تماس کسب‌وکار خود را درج نمایید. آدرس و کدپستی شرکت‌های حقوقی در مرحله تایید کسب‌وکار، در صورت نیاز توسط کارشناسان پادیوم بررسی می‌شود."
      />
      <Grid container item xs={12} spacing={5}>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <Grid container spacing={3}>
            <ProvinceCityListComponent methods={methods} initialState={province} initialCity={city} isRequired={true}/>
            <Grid item xs={12}>
              <InputV2
                errors={methods.formState.errors}
                ullWidth
                multiline
                name="address"
                label="آدرس"
                defaultValue=""
                register={methods.register}
                rules={['required', 'isLt|250']}
                fullWidth
                control={methods.control}
                inputProps={{ style: { marginBottom: 0, minHeight: 100 } }}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="postalcode"
                label="کد پستی"
                register={methods.register}
                //rules={['isNumeric','required']}
                rules={['required', 'isCorrectPostalCode']}
                dir="ltr"
                englishNumber
                fullWidth
                control={methods.control}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="phone"
                label="تلفن ثابت"
                register={methods.register}
                rules={['isNumeric']}
                dir="ltr"
                englishNumber
                fullWidth
                control={methods.control}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="faxNumber"
                label="فکس"
                register={methods.register}
                rules={['isNumeric']}
                dir="ltr"
                englishNumber
                fullWidth
                control={methods.control}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="legalInfo.website"
                label="آدرس وب سایت"
                defaultValue=""
                register={methods.register}
                fullWidth
                rows={5}
                dir="ltr"
                control={methods.control}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <InputV2
                errors={methods.formState.errors}
                name="email"
                style={{ 'direction': 'ltr' }}
                label="پست الکترونیک"
                register={methods.register}
                rules={nationalCode?.length > 0 ? ['required', 'isEmail', 'isLt|60'] : ['isEmail', 'isLt|60']}
                fullWidth
                rows={5}
                dir="ltr"
                control={methods.control}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={12} md={6} lg={6} xl={6}>
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.mapContainer}>
              <Grid container className={classes.searchContainer} spacing={3}>
                <Grid item xs={11} className={classes.searchBox}>
                  <AutocompleteV
                    control={methods.control}
                    errors={methods.formState.errors}
                    register={methods.register}
                    name="search"
                    dir="rtl"
                    fullWidth
                    list={searchResult}
                    getOptionSelected={(option, value) => option.id === value.id}
                    inputValue={locationSearchText}
                    onInputChange={(e) => {
                      setLocationSearchText(e?.target?.value ?? '');
                    }}
                    onChangeValue={(p) => {
                      if (!p) return;
                      setLocationSearchText(p.label);
                      setLatitude({ lat: p.latitude.y, lng: p.latitude.x });
                      setSelectedLocation(true);
                    }}
                    preventAddCustomOption
                  />
                </Grid>
              </Grid>
              <NeshanMap
                ref={map}
                style={{ width: '100%' }}
                options={{
                  key: `${process.env.REACT_APP_NESHAN_MAP_KEY}`,
                  maptype: 'dreamy-gold',
                  poi: true,
                  traffic: false,
                  center: [latitude.lat, latitude.lng],
                  zoom: 10,
                }}
                onInit={(L, myMap) => {
                  map.current = myMap;

                  marker.current = L.marker([latitude.lat, latitude.lng])
                    .addTo(myMap)
                    .bindPopup('نشانه گذار نقشه');

                  myMap.on('click', (event) => {
                    setLatitude({ lat: event.latlng.lat, lng: event.latlng.lng });

                    marker.current?.addTo(myMap).setLatLng(event?.latlng);
                  });
                  myMap.flyTo([latitude.lat, latitude.lng], 15);
                }}
              />
            </Grid>
          </Grid>
        </Grid> */}
      </Grid>
    </Grid>
  );
};

export default ContactUs;
